import { useState } from "react";
import {
  BagianConstant,
  RoleConstant,
  kepalaShiftTimOne,
  kepalaShiftTimTwo,
  posisiConstant,
} from "../../../constant";
import axios from "axios";
import moment from "moment";
import "../../../component/AccordionEditUser/AccordionEditUser.css";
import "../EditUser/EditUser.css";
import "./AddUser.css";

const Field = ({ label, required, error, full, children }) => (
  <div
    className={`field ${full ? "field--full" : ""} ${
      error ? "field--error" : ""
    }`}
  >
    <label className="field__label">
      {label}
      {required && <span className="field__req"> *</span>}
    </label>
    {children}
  </div>
);

const Radio = ({ label, checked, onSelect }) => (
  <label className="radio">
    <input type="radio" checked={checked} onChange={onSelect} />
    <span>{label}</span>
  </label>
);

const Section = ({ title, children }) => (
  <section className="form-section">
    <h2 className="form-section__title">{title}</h2>
    <div className="form-grid">{children}</div>
  </section>
);

const noWheel = (e) => e.target.blur();

const AddUser = () => {
  const getToken = localStorage.getItem("auth")
    ? localStorage.getItem("auth")
    : null;

  const getTim = localStorage.getItem("user");
  const jsonGetTim = JSON.parse(getTim);

  const [popUp, setPopUp] = useState(false);

  const [nama, setNama] = useState("");
  const [ktpNumber, setKtpNumber] = useState("");
  const [npwpNumber, setNpwpNumber] = useState("");
  const [teleponNumber, setTeleponNumber] = useState("");
  const [email, setEmail] = useState("");
  const [bankNumber, setBankNumber] = useState("");
  const [address, setAddress] = useState("");
  const [bagian, setBagian] = useState("");
  const [kepalaShift, setKepalaShift] = useState("Pilih Kepala");
  const [role, setRole] = useState([]);

  const toggleRole = (item) =>
    setRole((prev) =>
      prev.includes(item) ? prev.filter((r) => r !== item) : [...prev, item]
    );
  const [employeeType, setEmployeeType] = useState("");
  const [statusPerkawinan, setStatusPerkawinan] = useState("");
  const [totalChildren, setTotalChildren] = useState("");
  const [basicSallary, setBasicSallary] = useState("");
  const [position, setPosition] = useState("");
  const [tempatTanggalLahir, setTempatTanggalLahir] = useState("");
  const [uangMakan, setUangMakan] = useState("");
  const [uangTransport, setUangTransport] = useState("");
  const [bpjsK, setBpjsK] = useState("");
  const [bpjsTK, setBpjsTK] = useState("");
  const [basicSallaryProbation, setBasicSallaryProbation] = useState("");
  const [kontrakAwal, setKontrakAwal] = useState("");
  const [statusProbation, setStatusProbation] = useState(true);
  const [probationStart, setProbationStart] = useState(null);
  const [probationUntil, setProbationUntil] = useState(null);

  const [isError, setIsError] = useState(false);
  const [isErrMsg, setIsErrMsg] = useState(false);

  const validateData =
    jsonGetTim.tim === 1 ? kepalaShiftTimOne : kepalaShiftTimTwo;

  const handleReset = () => {
    setNama("");
    setKontrakAwal("");
    setKtpNumber("");
    setNpwpNumber("");
    setTeleponNumber("");
    setEmail("");
    setBankNumber("");
    setAddress("");
    setBagian("");
    setRole([]);
    setEmployeeType("");
    setStatusPerkawinan("");
    setTotalChildren("");
    setBasicSallary("");
    setPosition("");
    setTempatTanggalLahir("");
    setUangMakan("");
    setUangTransport("");
    setBpjsK("");
    setBpjsTK("");
    setBasicSallaryProbation("");
    setKepalaShift("Pilih Kepala");
    setProbationStart(null);
    setProbationUntil(null);
    setStatusProbation(true);
    setIsErrMsg(false);
  };
  const validateNama = nama.split(" ").slice(0, 2).join(".");

  const handleTim =
    jsonGetTim.tim === 1 ? validateNama.toLowerCase() : validateNama;

  const handleAddUser = async () => {
    if (
      kepalaShift !== "Pilih Kepala" &&
      nama !== "" &&
      ktpNumber !== "" &&
      role.length > 0 &&
      employeeType !== ""
    ) {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_ENDPOINT}/addUser`,
          {
            id: ktpNumber,
            name: nama,
            role: role,
            employeeType: employeeType,
            totalWorking: 0,
            totalOT: 0,
            basicSallary: Number(basicSallary),
            basicSallaryProbation: Number(basicSallaryProbation),
            password: "Tim123",
            username: handleTim,
            position: position,
            alamat: address,
            npwpNumber: npwpNumber,
            phoneNumber: teleponNumber,
            email: email,
            bankAccountNumber: bankNumber,
            shiftSatu: 0,
            uangMakan: uangMakan === "" ? 0 : Number(uangMakan),
            uangTransport: uangTransport === "" ? 0 : Number(uangTransport),
            kurangBayar: 0,
            lebihBayar: 0,
            bpjsTK: bpjsTK === "" ? 0 : Number(bpjsTK),
            bpjsK: bpjsK === "" ? 0 : Number(bpjsK),
            lemburLibur: 0,
            setengahHari: 0,
            shift: 1,
            bagian: bagian,
            kasbon: 0,
            kasbonTemp: 0,
            statusPerkawinan: statusPerkawinan,
            jumlahAnak: Number(totalChildren),
            workingShiftOne: 0,
            waktuCicilan: 0,
            token: "",
            deviceId: "",
            jamLebih: 0,
            tempatTanggalLahir: tempatTanggalLahir,
            tim: jsonGetTim.tim,
            kontrakAwal: kontrakAwal,
            kepalaShift: kepalaShift,
            totalWorkingProbation: 0,
            lemburLiburProbationShiftOne: 0,
            workingShiftOneProbation: 0,
            probation: statusProbation,
            probationStart: probationStart,
            probationUntil: probationUntil,
          },
          {
            headers: {
              Authorization: `Bearer ${getToken}`,
            },
          }
        );
        if (response.data.code === 200) {
          setIsError(false);
          setPopUp(true);
          setIsErrMsg(false);
        } else {
          // Sebelumnya popup tidak ditampilkan saat gagal (KTP sudah ada)
          setIsError(true);
          setPopUp(true);
        }
      } catch (error) {
        return error;
      }
    } else {
      setIsErrMsg(true);
    }
  };

  const handleClosePopUp = () => {
    // Saat gagal, form tidak direset supaya data bisa dikoreksi
    if (!isError) handleReset();
    setIsError(false);
    setPopUp(false);
  };

  const handlePickTanggalStart = (data) => {
    let endDate = moment(data)
      .utcOffset("+0700")
      .add(+13, "days")
      .format("YYYY-MM-DD");
    setProbationStart(data);
    setProbationUntil(endDate);
  };

  // Hanya kolom wajib yang masih kosong yang ditandai merah
  const err = {
    nama: isErrMsg && nama === "",
    ktp: isErrMsg && ktpNumber === "",
    role: isErrMsg && role.length === 0,
    employeeType: isErrMsg && employeeType === "",
    kepalaShift: isErrMsg && kepalaShift === "Pilih Kepala",
  };

  return (
    <div className="container-adduser">
      {popUp && (
        <div className="modal-overlay">
          <div className="modal" role="dialog" aria-modal="true">
            <div className="modal__body">
              <p className="eu-dialog-text">
                {isError
                  ? "User sudah ada di database. Mohon periksa lagi No. KTP."
                  : "User baru berhasil ditambahkan!"}
              </p>
            </div>
            <div className="modal__footer">
              <button className="btn btn--primary" onClick={handleClosePopUp}>
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="wrapper-card-adduser">
        <header className="au-header">
          <h1 className="au-title">Tambah karyawan</h1>
          <p className="au-subtitle">
            Kolom bertanda <span className="field__req">*</span> wajib diisi.
          </p>
        </header>

        <div className="au-body">
          <div className="au-body__inner">
            <Section title="Data pribadi">
              <Field label="Nama" required error={err.nama}>
                <input
                  type="text"
                  value={nama}
                  onChange={(e) => setNama(e.target.value)}
                />
              </Field>
              <Field label="No. KTP" required error={err.ktp}>
                <input
                  type="number"
                  value={ktpNumber}
                  onChange={(e) => setKtpNumber(e.target.value)}
                  onWheel={noWheel}
                />
              </Field>
              <Field label="No. NPWP">
                <input
                  type="number"
                  value={npwpNumber}
                  onChange={(e) => setNpwpNumber(e.target.value)}
                  onWheel={noWheel}
                />
              </Field>
              <Field label="Tempat tanggal lahir">
                <input
                  type="text"
                  value={tempatTanggalLahir}
                  onChange={(e) => setTempatTanggalLahir(e.target.value)}
                />
              </Field>
              <Field label="Status perkawinan">
                <div className="radio-group">
                  <Radio
                    label="Kawin"
                    checked={statusPerkawinan === "KAWIN"}
                    onSelect={() => setStatusPerkawinan("KAWIN")}
                  />
                  <Radio
                    label="Tidak kawin"
                    checked={statusPerkawinan === "TIDAK KAWIN"}
                    onSelect={() => setStatusPerkawinan("TIDAK KAWIN")}
                  />
                </div>
              </Field>
              <Field label="Jumlah anak">
                <input
                  type="number"
                  value={totalChildren}
                  onChange={(e) => setTotalChildren(e.target.value)}
                  onWheel={noWheel}
                />
              </Field>
              <Field label="Alamat" full>
                <textarea
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </Field>
            </Section>

            <Section title="Kontak dan rekening">
              <Field label="No. telepon">
                <input
                  type="number"
                  value={teleponNumber}
                  onChange={(e) => setTeleponNumber(e.target.value)}
                  onWheel={noWheel}
                />
              </Field>
              <Field label="Email">
                <input
                  type="text"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Field>
              <Field label="No. rekening">
                <input
                  type="number"
                  value={bankNumber}
                  onChange={(e) => setBankNumber(e.target.value)}
                  onWheel={noWheel}
                />
              </Field>
            </Section>

            <Section title="Pekerjaan">
              <Field label="Posisi">
                <select
                  value={position}
                  onChange={(e) => setPosition(e.target.value)}
                >
                  <option value="" disabled hidden>
                    Pilih posisi
                  </option>
                  {posisiConstant.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </Field>
              <Field label="Bagian">
                <select
                  value={bagian}
                  onChange={(e) => setBagian(e.target.value)}
                >
                  <option value="" disabled hidden>
                    Pilih bagian
                  </option>
                  {BagianConstant.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </Field>
              <Field
                label="Role (bisa lebih dari satu)"
                required
                error={err.role}
                full
              >
                <div className="role-group">
                  {RoleConstant.map((item) => (
                    <label
                      key={item}
                      className={`role-chip ${
                        role.includes(item) ? "is-on" : ""
                      }`}
                    >
                      <input
                        type="checkbox"
                        checked={role.includes(item)}
                        onChange={() => toggleRole(item)}
                      />
                      <span>{item}</span>
                    </label>
                  ))}
                </div>
              </Field>
              <Field label="Kepala shift" required error={err.kepalaShift}>
                <select
                  value={kepalaShift}
                  onChange={(e) => setKepalaShift(e.target.value)}
                >
                  <option value="Pilih Kepala" disabled>
                    Pilih kepala
                  </option>
                  {validateData.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </Field>
              <Field label="Jenis karyawan" required error={err.employeeType}>
                <div className="radio-group">
                  <Radio
                    label="Permanen"
                    checked={employeeType === "Permanent"}
                    onSelect={() => setEmployeeType("Permanent")}
                  />
                  <Radio
                    label="Kontrak"
                    checked={employeeType === "Contract"}
                    onSelect={() => setEmployeeType("Contract")}
                  />
                </div>
              </Field>
              <Field label="Kontrak awal">
                <input
                  type="text"
                  value={kontrakAwal}
                  onChange={(e) => setKontrakAwal(e.target.value)}
                />
              </Field>
            </Section>

            <Section title="Gaji dan tunjangan">
              <Field label="Gaji pokok">
                <input
                  type="number"
                  value={basicSallary}
                  onChange={(e) => setBasicSallary(e.target.value)}
                  onWheel={noWheel}
                />
              </Field>
              <Field label="Uang makan">
                <input
                  type="number"
                  value={uangMakan}
                  onChange={(e) => setUangMakan(e.target.value)}
                  onWheel={noWheel}
                />
              </Field>
              <Field label="Uang transport">
                <input
                  type="number"
                  value={uangTransport}
                  onChange={(e) => setUangTransport(e.target.value)}
                  onWheel={noWheel}
                />
              </Field>
              <Field label="BPJS Kesehatan">
                <input
                  type="number"
                  value={bpjsK}
                  onChange={(e) => setBpjsK(e.target.value)}
                  onWheel={noWheel}
                />
              </Field>
              <Field label="BPJS Tenaga Kerja">
                <input
                  type="number"
                  value={bpjsTK}
                  onChange={(e) => setBpjsTK(e.target.value)}
                  onWheel={noWheel}
                />
              </Field>
              <Field label="Gaji probation">
                <input
                  type="number"
                  value={basicSallaryProbation}
                  onChange={(e) => setBasicSallaryProbation(e.target.value)}
                  onWheel={noWheel}
                />
              </Field>
            </Section>
            <Section title="Masa percobaan">
              <Field label="Status percobaan">
                <div className="radio-group">
                  <Radio
                    label="Ya"
                    checked={statusProbation === true}
                    onSelect={() => setStatusProbation(true)}
                  />
                  <Radio
                    label="Tidak"
                    checked={statusProbation === false}
                    onSelect={() => setStatusProbation(false)}
                  />
                </div>
              </Field>
              <Field label="Percobaan dari">
                <input
                  type="date"
                  value={probationStart ?? ""}
                  onChange={(e) => handlePickTanggalStart(e.target.value)}
                />
              </Field>
              <Field label="Percobaan sampai">
                <div className="field__value">{probationUntil || "-"}</div>
              </Field>
            </Section>
          </div>
        </div>

        <footer className="au-footer">
          {isErrMsg && (
            <span className="au-alert" role="alert">
              Lengkapi kolom wajib yang ditandai merah.
            </span>
          )}
          <button className="btn btn--outline" onClick={() => handleReset()}>
            Reset
          </button>
          <button className="btn btn--primary" onClick={() => handleAddUser()}>
            Simpan
          </button>
        </footer>
      </div>
    </div>
  );
};
export default AddUser;
